import React, { useContext, useEffect, useState } from "react";
import { fetchRcOrganizations } from "../../../service/Report";
import AppContext from "../../../context/AppContext";
import translations from "../Translations";

const RcOrganization = () => {
    const [organizations, setOrganizations] = useState([]);
    const { rcOrgId,setSelectedOrgId, setRcOrgId, rcOrgName, setRcOrgName, theme, langMode } = useContext(AppContext);

    useEffect(() => {
        setSelectedOrgId(rcOrgId)
      }, [rcOrgId])

    useEffect(() => {
        const loadOrganizations = async () => {
            try {
                const orgs = await fetchRcOrganizations();
                setOrganizations(orgs);
                const savedOrgId = localStorage.getItem("RcselectedOrgId");
                const savedOrgName = localStorage.getItem("RcselectedOrgName");
                if (savedOrgId && savedOrgName) {
                    setRcOrgId(Number(savedOrgId));
                    setRcOrgName(savedOrgName);
                } else if (orgs.length > 0) {
                    const defaultOrg = orgs.find((org) => org.organizationId === 1) || orgs[0];
                    if (defaultOrg) {
                        setRcOrgId(defaultOrg.organizationId);
                        setRcOrgName(defaultOrg.organizationName);
                        localStorage.setItem("RcselectedOrgId", defaultOrg.organizationId);
                        localStorage.setItem("RcselectedOrgName", defaultOrg.organizationName);
                    }
                }
            } catch (error) {
                console.error("Error loading organizations:", error);
            }
        };

        loadOrganizations();
    }, []);

  useEffect(() => {
    setSelectedOrgId(rcOrgId)
  }, [rcOrgId])

    const handleOrganizationChange = (selectedName) => {
        const selectedOrg = organizations.find((org) => org.organizationName === selectedName);
        if (selectedOrg) {
            setRcOrgId(selectedOrg.organizationId);
            setRcOrgName(selectedOrg.organizationName);
            localStorage.setItem("RcselectedOrgId", selectedOrg.organizationId);
            localStorage.setItem("RcselectedOrgName", selectedOrg.organizationName);
        }
    };

    return (
        <div>
            <select
                value={rcOrgName}
                onChange={(e) => handleOrganizationChange(e.target.value)}
                className={`org cursor-pointer w-56 mr-2 max-w-xs block px-2.5 text-sm text-center text-black bg-transparent rounded-xl appearance-none bg-white  
          ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""}`}
            >
                <option value="" disabled>
                    {translations[langMode].selectOrg}
                </option>
                {organizations.map((org) => (
                    <option key={org.organizationId} value={org.organizationName}>
                        {org.organizationName}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default RcOrganization;
